import sortBy from 'lodash/sortBy'
import { ALIGNMENT_SERVICE } from './constants'

export const getFreeAlignmentCheckBlockState = ({
  quotedItemAndServices: {
    services = []
  } = {},
  freeAligmentTooltip = {}
} = {}) =>
  services && services.length !== 0 &&
    services.some(({ serviceId }) => serviceId === ALIGNMENT_SERVICE)

export const getItemWithFilteredServices = ({
  quotedItemAndServices: {
    services = [],
    ...restItems
  },
  freeAligmentTooltip = {}
} = {}) => ({
  ...restItems,
  services: services && services.filter(service => service.commerceItemId !== freeAligmentTooltip.commerceItemId)
})

export const getProductsWithChangedPrice = ({ products = []}) =>
  products && products.filter(({ hasPriceChanged, price }) => hasPriceChanged && parseFloat(price) > 0)

export const sortProducts = (products) => sortBy(products, 'isActive')

export const validateForm = ({
  hasActiveVehicle,
  hasStore,
  storeApptEnabled
}) => {
  const errors = []
  if (!hasActiveVehicle) {
    errors.push('Please select a vehicle')
  }
  if (!hasStore) {
    errors.push('Please select a store')
  } else if (!storeApptEnabled) {
    errors.push('Please select a store with available appointments')
  }
  return errors
}
